import { BRAND_VALUE_FILTER_TYPE, buildFilterKey } from "@faire/retailer-shared/filters/filterKeys";
// We support the URL suffix /brandValue/:brandValue for SEO purpose
// this value should be treated as an initial value for filters and the
// "filters" property from query parameter takes precedence
//
// Also we prefer dash to underscore in URL, so need to do a conversion before
// using the value
export var getBrandValuesFilterKey = function(routeBrandValuesValue) {
    var matchedFilterByBrandValue = routeBrandValuesValue === null || routeBrandValuesValue === void 0 ? void 0 : routeBrandValuesValue.replace(/-/g, "_");
    if (matchedFilterByBrandValue) {
        var brandValueFilterKey = buildFilterKey(BRAND_VALUE_FILTER_TYPE, matchedFilterByBrandValue);
        return brandValueFilterKey;
    }
    return;
};
